import type { SurveyStatus } from '@/types/survey';

/** Human labels and badge styling for each survey status. */
export const STATUS_LABELS: Record<SurveyStatus, string> = {
  draft: 'Not Started',
  ready: 'Not Started',
  recording: 'Recording',
  completed: 'Completed',
  pending_sync: 'Pending Sync',
  synced: 'Synced',
};

export const STATUS_BADGE_STYLES: Record<SurveyStatus, string> = {
  draft: 'bg-slate-100 text-slate-700',
  ready: 'bg-slate-100 text-slate-700',
  recording: 'bg-red-600 text-white',
  completed: 'bg-amber-100 text-amber-900',
  pending_sync: 'bg-amber-100 text-amber-900',
  synced: 'bg-emerald-100 text-emerald-900',
};

export const STATUS_CHIP_STYLES: Record<SurveyStatus, string> = {
  draft: 'bg-slate-100 text-slate-700',
  ready: 'bg-slate-100 text-slate-700',
  recording: 'bg-red-100 text-red-800',
  completed: 'bg-amber-100 text-amber-900',
  pending_sync: 'bg-amber-100 text-amber-900',
  synced: 'bg-emerald-100 text-emerald-900',
};

export function statusLabel(status: SurveyStatus): string {
  return STATUS_LABELS[status];
}
